import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';

interface FormActionsProps {
    cancelTo: string;
    cancelTitle?: string;
    loading?: boolean;
    hide?: boolean;
}

function FormActions(props: FormActionsProps) {
    const { cancelTo, cancelTitle, loading, hide } = props;
    const { t } = useTranslation();

    if (hide)
        return null;

    return (
        <div className="mt-6 flex items-center justify-end gap-x-6">
            <Button
                to={cancelTo}
                title={cancelTitle || t('common.cancel')}
                color="navigateBack"
                icon="back"
            />
            <Button
                type="submit"
                title={t('common.save')}
                color="primary"
                icon={loading ? 'loading' : 'save'}
                loading={loading}
            />
        </div>
    );
}

export default FormActions;
